<template>
  <div
    class="el-select-dropdown el-popper"
    :class="[{ 'is-multiple': $parent.multiple }, popperClass]"
    :style="{ minWidth: minWidth }"
  >
    <slot></slot>
  </div>
</template>

<script type="text/babel">
import Popper from 'element-ui/lib/utils/vue-popper';

export default {
  name: 'ElSelectDropdown',

  componentName: 'ElSelectDropdown',

  mixins: [Popper],

  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },

    boundariesPadding: {
      type: [String, Number],
      default: 0
    },

    popperOptions: {
      type: Object,
      default () {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      minWidth: ''
    };
  },

  computed: {
    popperClass () {
      return this.$parent.popperClass;
    }
  },

  watch: {
    '$parent.inputWidth' () {
      this.minWidth = this.$parent.inputWidth + 'px';
    }
  },

  mounted () {
    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', () => {
      if (this.$parent.visible) this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
};
</script>



// WEBPACK FOOTER //
// select-dropdown.vue?4a76e368